import React from "react";
import PropTypes from "prop-types";
import StyledIcon from "./styledIcon";

const Anexo = ({ fill, ...props }) => (
  <StyledIcon viewBox="0 0 16 16" {...props}>
    <g clipPath="url(#clip0_29872_7435)">
      <path
        d="M4.38639 12.3333C3.15508 12.3333 2.11114 11.905 1.25457 11.0485C0.398009 10.1919 -0.0302734 9.14798 -0.0302734 7.91667C-0.0302734 6.68535 0.398009 5.64141 1.25457 4.78485C2.11114 3.92828 3.15508 3.5 4.38639 3.5H12.8182C13.7015 3.5 14.4577 3.81452 15.0868 4.44356C15.7158 5.0726 16.0303 5.82879 16.0303 6.71212C16.0303 7.59545 15.7158 8.35164 15.0868 8.98068C14.4577 9.60972 13.7015 9.92424 12.8182 9.92424H5.18942C4.6273 9.92424 4.15218 9.73018 3.76404 9.34204C3.37591 8.95391 3.18185 8.47879 3.18185 7.91667C3.18185 7.35455 3.37591 6.87942 3.76404 6.49129C4.15218 6.10316 4.6273 5.90909 5.18942 5.90909H12.2159C12.3899 5.90909 12.5339 5.96584 12.648 6.07933C12.7615 6.19336 12.8182 6.33737 12.8182 6.51136C12.8182 6.68535 12.7615 6.8291 12.648 6.94259C12.5339 7.05662 12.3899 7.11364 12.2159 7.11364H5.18942C4.9619 7.11364 4.77131 7.19046 4.61767 7.34411C4.46348 7.49829 4.38639 7.68914 4.38639 7.91667C4.38639 8.14419 4.46348 8.33478 4.61767 8.48842C4.77131 8.64261 4.9619 8.7197 5.18942 8.7197H12.8182C13.3803 8.7197 13.8555 8.52563 14.2436 8.1375C14.6317 7.74937 14.8258 7.27424 14.8258 6.71212C14.8258 6.15 14.6317 5.67487 14.2436 5.28674C13.8555 4.89861 13.3803 4.70455 12.8182 4.70455H4.38639C3.50306 4.70455 2.74687 5.01907 2.11783 5.64811C1.48879 6.27715 1.17427 7.03333 1.17427 7.91667C1.17427 8.8 1.48879 9.55619 2.11783 10.1852C2.74687 10.8143 3.50306 11.1288 4.38639 11.1288H12.2159C12.3899 11.1288 12.5339 11.1855 12.648 11.299C12.7615 11.4131 12.8182 11.5571 12.8182 11.7311C12.8182 11.9051 12.7615 12.0491 12.648 12.1631C12.5339 12.2766 12.3899 12.3333 12.2159 12.3333H4.38639Z"
        fill="#FF8B22"
      />
    </g>
    <defs>
      <clipPath id="clip0_29872_7435">
        <rect width="16" height="16" fill={fill} />
      </clipPath>
    </defs>
  </StyledIcon>
);

Anexo.propTypes = {
  fill: PropTypes.string
};

Anexo.defaultProps = {
  fill: "white"
};

export default Anexo;
